import {Component, OnDestroy, OnInit} from "@angular/core";
import {Website} from "../../website";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {distinctUntilChanged, filter, switchMap, takeUntil} from "rxjs/operators";
import {combineLatest, Subject} from "rxjs";
import {Product} from "../../product";


@Component({
    selector: 'db-ecommerce-tax',
    templateUrl: './ecommerce-tax.component.html',
    styleUrls: ['./ecommerce-tax.component.scss'],
    standalone: false
})
export class EcommerceTaxComponent implements OnInit, OnDestroy {

  public website: Website;
  public loading: boolean;
  public calcTaxes: boolean;
  public connectTaxesEnabled: boolean;
  public connectTaxes: boolean;
  public activeTab: string = 'main';
  public taxPlugin: Product;
  private readonly _destroyStream$ = new Subject<boolean>();

  constructor(
      private readonly _store: Store<fromStore.DbStoreState>,
      private _route: ActivatedRoute,
      private _activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.website = this._activatedRoute.snapshot.parent.parent.data['website'];
    this.taxPlugin = this._route.snapshot.data['taxPlugin'];
    const queryParams: any = (<any>this._route.queryParams).value;
    if (queryParams?.tab && queryParams?.tab === 'settings') {
      this.activeTab = 'settings';
    }
    this._getData();
    this._getGeneralSettings();
  }

  ngOnDestroy() {

  }

  public setTabChange($event): void {
    this.activeTab = $event?.tabId;
  }

  private _getData(): void {
    this._store.select(fromStore.getWebsitePluginsLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getWebsiteEcommerceTaxPlugin(this.website?.id))
        )),
        distinctUntilChanged(([taxPluginOld], [taxPluginNew]) => taxPluginOld && taxPluginNew && taxPluginOld.active === taxPluginNew.active),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([taxPluginProduct]) => {
        if (taxPluginProduct) {
          this.taxPlugin = taxPluginProduct;
        }
      });
  }

  private _getGeneralSettings(): void {
    this._store.select(fromStore.getEcommerceGeneralSettingsLoaded(this.website?.id))
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => combineLatest(
                this._store.select(fromStore.getEcommerceCalcTaxes(this.website?.id)),
                this._store.select(fromStore.getEcommerceGeneralSettings(this.website?.id)),
                this._store.select(fromStore.getEcommerceConnectTaxesEnabled(this.website?.id))
            )),
          filter(([calcTaxes, generalSettings, connectTaxesEnabled]) => !!calcTaxes?.value && !!generalSettings ),
          takeUntil(this._destroyStream$)
        )
        .subscribe(([calcTaxes, generalSettings, connectTaxesEnabled]) => {
          this.calcTaxes = calcTaxes?.value === 'yes';
          this.connectTaxes = !connectTaxesEnabled?.length;
          this.connectTaxesEnabled = connectTaxesEnabled?.value === 'yes';
        });
  }


}
